var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoorClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_95620177791570007862165897052514667223",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_237887818079196896204618882072996990344",
    d: "M17 0c.552 0 1 .448 1 1v24c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h16zm-1.5 1.444h-13c-.513 0-.936.386-.993.884l-.007.116v21.112c0 .512.386.935.883.993l.117.007h13c.513 0 .936-.386.993-.884l.007-.116V2.444c0-.552-.448-1-1-1zm-.5 8.667v1.445h-1.5v2.888H15v1.445h-1.556c-.797 0-1.444-.647-1.444-1.445v-2.888c0-.798.647-1.445 1.444-1.445H15z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_232034441668550407200195569382758629057",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_237887818079196896204618882072996990344"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#hinava_random_uuid_237887818079196896204618882072996990344"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#hinava_random_uuid_95620177791570007862165897052514667223)",
    mask: "url(#hinava_random_uuid_232034441668550407200195569382758629057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    transform: "translate(-7 -3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorClose);
export default __webpack_public_path__ + "static/media/door-close.3e21ba34d350abe5e75b376a3b4f58f8.svg";
export { ForwardRef as ReactComponent };